export default __webpack_public_path__ + "static/media/js.19600440.svg";